// extracted by mini-css-extract-plugin
export default {"card":"styles_card__ruTg-","title":"styles_title__uBwIO","illustration":"styles_illustration__S21MM","textBody":"styles_textBody__Yv8Zz","button":"styles_button__DTHiV"};